<template>
  <div>
    <PageMain
      ref="main"
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      :disabled="disabled"
      @reload="reload"
      @openEdit="openEdit"
      @purchasableApply="purchasableApplyApi"
      @informationReview="informationReviewApi"
      @checkbox-change="(data) => (checkedRows = data)"
      @copy-to-spu="copyToSpu"
    >
      <div slot="header" class="mb-2">
        <PageHeader
          ref="header"
          :disabled="disabled"
          :checkedRowCount="checkedRowCount"
          @openEdit="openEdit"
          @query="getData"
          @reset="resetPage"
          @resetChecked="resetChecked"
          @purchasableApply="purchasableApply"
          @informationReview="informationReview"
          @clearCheckboxRow="clearCheckboxRow"
        />
      </div>

      <pagination
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </PageMain>

    <SkuEditForm
      v-if="skuEditFormOpts.visible"
      :visible.sync="skuEditFormOpts.visible"
      :evgSpuCode="evgSpuCode"
      :evgSkuCode="skuEditFormOpts.evgSkuCode"
      :optType="skuEditFormOpts.optType"
      @close="reload"
    />

    <ChooseEvgSpu
      ref="chooseEvgSpu"
      :visible.sync="copySkuOpts.visible"
      :evgSpuCode="evgSpuCode"
      :title="$l('dialog_title_chooseToSpu') || '选择复制目标SPU'"
      :confirm-on-close="false"
      @confirm="copyConfirm"
    />
  </div>
</template>
<script>
import PageMain from './main.vue'
import PageHeader from './header.vue'
import SkuEditForm from '../sku-edit-form'
import ChooseEvgSpu from '../choose-evg-spu'
import EditLoading from '@/mixins/edit-loading'
import BaseTable from '@/mixins/base-table'
export default {
  mixins: [EditLoading, BaseTable],
  components: { PageMain, PageHeader, SkuEditForm, ChooseEvgSpu },
  props: {
    evgSpuCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      usePage: true,
      checkedRows: [],
      skuEditFormOpts: { visible: false, optType: '', evgSkuCode: '' },
      copySkuOpts: { evgSkuCode: '', visible: false },
    }
  },
  computed: {
    checkedRowCount() {
      return this.checkedRows?.length || 0
    },
  },
  methods: {
    getData(form) {
      this.loading = true
      const params = { evgSpuCode: this.evgSpuCode, ...this.page, ...form }
      this.$api
        .ecomEvgSkuListBySpuCodeApi(params)
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    handlePaginationChange(val) {
      this.page = {
        curPage: val.current,
        pageSize: val.size,
        pageTotal: val.total,
      }
      this.reload()
    },
    clearCheckboxRow() {
      this.checkedRows = []
      this.$refs.main.clearCheckboxRow()
    },
    openEdit({ type: optType, data = {} }) {
      const { evgSkuCode = '' } = data
      this.skuEditFormOpts = { visible: true, optType, evgSkuCode }
    },
    resetChecked() {
      this.clearCheckboxRow()
    },
    purchasableApply() {
      if (!this.checkedRows || !this.checkedRows.length) {
        this.$message({
          message:
            this.$l('tips_purchasableApply_message') ||
            '请选择需要申请可下单的SKU',
          type: 'warning',
        })
        return
      }
      const listEvgSkuCode = this.checkedRows.map((item) => item.evgSkuCode)
      this.purchasableApplyApi(listEvgSkuCode)
    },
    async purchasableApplyApi(listEvgSkuCode) {
      const confirm = await this.$confirm(
        this.$l('tips_confirm_purchasableApply_content') ||
          '是否要申请可下单？',
        this.$l('tips_confirm_purchasableApply_title') || '确认信息',
        {
          confirmButtonText: this.$l('btn_purchasableApply_confirm') || '确定',
          cancelButtonText: this.$l('btn_purchasableApply_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return
      if (this.loadingOpen()) return
      const res = await this.$api
        .ecomEvgSkuPurchasableApplyApi({ listEvgSkuCode })
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(
          this.$l('tips_purchasableApply_error') || '申请失败！'
        )
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('tips_purchasableApply_success') || '申请成功！',
        type: 'success',
      })
      this.resetChecked()
      this.$refs.header.query()
    },
    informationReview() {
      if (!this.checkedRows || !this.checkedRows.length) {
        this.$message({
          message:
            this.$l('tips_informationReview_message') ||
            '请选择需要提交信息审核的SKU',
          type: 'warning',
        })
        return
      }
      const listEvgSkuCode = this.checkedRows.map((item) => item.evgSkuCode)
      this.informationReviewApi(listEvgSkuCode)
    },
    async informationReviewApi(listEvgSkuCode) {
      const confirm = await this.$confirm(
        this.$l('tips_confirm_informationReview_content') ||
          '是否要提交信息审核？',
        this.$l('tips_confirm_informationReview_title') || '确认信息',
        {
          confirmButtonText: this.$l('btn_informationReview_confirm') || '确定',
          cancelButtonText: this.$l('btn_informationReview_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return
      if (this.loadingOpen()) return
      const res = await this.$api
        .ecomEvgSkuInformationApplyApi({ listEvgSkuCode })
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(
          this.$l('tips_informationReview_error') || '提交失败！'
        )
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('tips_informationReview_success') || '提交成功！',
        type: 'success',
      })
      this.resetChecked()
      this.$refs.header.query()
    },
    copyToSpu({ evgSkuCode }) {
      this.copySkuOpts = { evgSkuCode, visible: true }
    },
    async copyConfirm(data) {
      if (!data) return
      const { evgSpuCode, evgSpuNo } = data
      const { evgSkuCode } = this.copySkuOpts

      const confirm = await this.$confirm(
        this.$l('tips_confirm_copyToSku') ||
          `是否确认将SKU复制到【${evgSpuNo}】SPU中吗？`,
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('btn_del_sku_confirm') || '确定',
          cancelButtonText: this.$l('btn_del_sku_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return

      if (this.loadingOpen()) return
      const res = await this.$api
        .ecomEvgSkuCopyApi({ evgSkuCode, evgSpuCode })
        .catch(() => null)
      this.loadingClose()
      if (!res) return

      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('tips_copy_no') || '复制失败！')
        return
      }

      this.$refs.chooseEvgSpu.close()

      this.$message({
        showClose: true,
        message: this.$l('tips_copy_ok') || '复制成功！',
        type: 'success',
      })
    },
  },
}
</script>
